import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import { observer } from 'mobx-react';
import sort from 'four-nets/icons/svg/icon_sorting-descending.svg';

import Localizable from 'lib/intl/localizable';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import defaultStyles from './order-filter-view.scss';


export interface Props {
    styles: typeof defaultStyles;
    orderBy: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    children: React.ReactNode[];
}

@Localizable()
@observer
class OrderFilterView extends React.Component<Props> {
    render() {
        const { styles, onChange, orderBy } = this.props;

        return (
            <div className={styles.select}>
                <SVGIcon style={{image: styles.icon}} src={sort} />
                <label htmlFor='order-filter-id' className={styles.label}>
                    <FormattedMessage id='BUTTON_LABEL_CHANGE_ORDER' />
                </label>
                <select id='order-filter-id' className={styles.element} onChange={onChange} value={orderBy}>
                    {this.props.children}
                </select>
            </div>
        );
    }
}

export default Styled(defaultStyles)(OrderFilterView);
